var render = function render() {
  var _vm = this,
    _c = _vm._self._c;
  return _c("div", [_c("AdminInventorySubMenusLinks", {
    attrs: {
      loggedUserData: _vm.loggedUserData
    },
    on: {
      tabChanged: _vm.tabChanged
    }
  }), _vm.isAdminNotConsultant(_vm.loggedUserData) ? _c("div", [_vm.selectedTab === _vm.tabs.items ? _c("div", [_c("StockList", {
    attrs: {
      loggedUserData: _vm.loggedUserData
    }
  })], 1) : _vm._e(), _vm.canManagePos && _vm.$whitelabel.isAllowedToAccessPurchaseOrder && _vm.selectedTab === _vm.tabs.purchaseOrder ? _c("div", [_c("PurchaseOrderList", {
    attrs: {
      loggedUserData: _vm.loggedUserData
    },
    on: {
      "click:row": function clickRow($event) {
        _vm.drawer = true;
      }
    }
  })], 1) : _vm._e(), _vm.$whitelabel.isAllowedToAccessPurchaseOrder && _vm.canManageSupplierPrices && _vm.selectedTab === _vm.tabs.supplierPrices ? _c("div", [_c("SupplierPricesList", {
    attrs: {
      loggedUserData: _vm.loggedUserData
    }
  })], 1) : _vm._e(), _vm.selectedTab === _vm.tabs.movements ? _c("div", [_c("MvtStockList")], 1) : _vm._e(), _vm.canManageWarehouses && _vm.selectedTab === _vm.tabs.warehouses ? _c("div", [_c("WarehouseList", {
    attrs: {
      loggedUserData: _vm.loggedUserData
    }
  })], 1) : _vm._e()]) : _vm._e()], 1);
};
var staticRenderFns = [];
render._withStripped = true;
export { render, staticRenderFns };